import General from './General';
import Auth from './Auth';

const Layouts = {
    General: General,
    Auth: Auth
};

export default Layouts;